<template>
  <div class="btmFix">
    <div>
      <van-button round @click="onShare" style="margin-right: 10px"
        ><img
          :src="sricon"
          style="width: 16px; margin-right: 4px"
        />Share</van-button
      >
      <van-button @click="toMap" round
        ><img
          :src="dwicon"
          style="width: 16px; margin-right: 4px"
        />Navigation</van-button
      >
    </div>
    <van-button
      icon="plus"
      :color="mainColor"
      @click="regHandler"
      v-if="showRegBtn"
      round
      >Free Visit</van-button
    >
  </div>
  <div class="shareMsk" v-show="showShareTip">
    <div class="shareTip">
      <img :src="sr" alt="" @click="showShareTip = false" />
      <!-- <div class="shareBtn" @click="showShareTip = false">确定</div> -->
    </div>
  </div>
</template>
<script setup>
import { ref, defineProps, defineEmits } from 'vue'
import sr from '@/assets/sr.png'
import sricon from '@/assets/sricon.png'
import dwicon from '@/assets/dwicon.png'
import router from '../router'
const mainColor = ref('#00479c')
const props = defineProps({
  showRegBtn: {
    type: Boolean,
    default: false
  }
})
const emits = defineEmits(['onReg'])
const regHandler = () => {
  emits('onReg')
}
const showShareTip = ref(false)
const onShare = () => {
  showShareTip.value = true
}
const toMap = () => {
  router.push({ path: '/map' })
}
</script>
<style lang="less" scoped>
.shareMsk {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
  .shareTip {
    // background: #fff;
    border-radius: 5px;
    width: 88%;
    margin: 8vh auto 0;
    p {
      padding: 8vh 2vh;
    }
    img {
      width: 60vw;
    }
  }
  .shareBtn {
    padding: 2.2vh;
    text-align: center;
    border-top: 1px solid #ececec;
  }
}
.btmFix {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
  padding: 0vh 6vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #eee;
  height: 10vh;
}
</style>
